import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {SettingsLabel} from 'ui-library/SettingsField';

interface StudySchemaGeneralSettingsProps {
  isDesignApprovalRequired: boolean;
  setIsDesignApprovalRequired: (isDesignApprovalRequired: boolean) => void;
}

export default function StudySchemaGeneralSettingsEditor(
  props: StudySchemaGeneralSettingsProps
): JSX.Element {
  return (
    <>
      <SettingsLabel label="Study Settings" />
      <div className="u-small-spacing-top">
        <CheckboxInput
          id="isDesignApprovalRequiredToggle"
          checked={props.isDesignApprovalRequired}
          onChange={(e) => {
            props.setIsDesignApprovalRequired(e.target.checked);
          }}
          label="Require approval of Design before proceeding to Execution"
          dataTestAttrs={{
            component: 'StudySchemaGeneralSettingsEditor',
            element: 'isDesignApprovalRequiredToggle',
          }}
        />
      </div>
    </>
  );
}
